import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ClientLayout from './components/client/ClientLayout';
import ClientPortal from './pages/ClientPortal';
import Features from './pages/Features';
import PricingPage from './pages/Pricing';
import FAQ from './pages/FAQ';
import Contact from './pages/Contact';
import AdminPortal from './pages/AdminPortal';
import SandboxDashboard from './components/client/SandboxDashboard';
import LoadingScreen from './components/shared/LoadingScreen';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Refund from './pages/Refund';
import SandboxLogin from './pages/SandboxLogin';
import ClientMessages from './pages/ClientMessages';
import ClientSubscriptions from './pages/ClientSubscriptions';
import { Toaster } from 'react-hot-toast';

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate initial app-shell load time
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1200);
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <>
      <Toaster position="top-center" toastOptions={{ duration: 4000, style: { background: '#1e293b', color: '#fff' } }} />
      <Router>
      <Routes>
        <Route path="/admin" element={<AdminPortal />} />
        <Route path="/sandbox-login" element={<SandboxLogin />} />
        <Route path="/sandbox" element={<SandboxDashboard />} />
        
        {/* Client Routes wrapped in Layout */}
        <Route element={<ClientLayout />}>
          <Route path="/" element={<ClientPortal />} />
          <Route path="/features" element={<Features />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/messages" element={<ClientMessages />} />
          <Route path="/subscriptions" element={<ClientSubscriptions />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/refund" element={<Refund />} />
        </Route>
      </Routes>
    </Router>
    </>
  );
}

export default App;
